import React from "react";
import "./AppFooter.scss";
import { Layout, theme } from "antd";
import { Link, useLocation } from "react-router-dom";
import Utils from "../../utils";

const { Footer } = Layout;

export default function AppFooter() {
  const { useToken } = theme;
  const { token } = useToken();
  const location = useLocation();

  return (
    <Footer
      className="appFooter-cont"
      style={{
        borderTop: `1px solid ${token?.Layout?.footerBorderTopColor}`,
      }}>
      <div className="appFooter-cont__textWrapper">
        <Link
          to="/about"
          style={{
            color: token?.Typography?.colorPrimaryText,
            borderBottom:
              location?.pathname === "/about"
                ? "1.5px solid currentColor"
                : "none",
          }}
          onClick={() => {
            Utils?.scrollIntoViewByClassName(".standardHeader-cont");
          }}>
          About
        </Link>
        <Link
          to="/business"
          style={{
            color: token?.Typography?.colorPrimaryText,
            borderBottom:
              location?.pathname === "/business"
                ? "1.5px solid currentColor"
                : "none",
          }}
          onClick={() => {
            Utils?.scrollIntoViewByClassName(".standardHeader-cont");
          }}>
          Business
        </Link>
      </div>
      <div className="appFooter-cont__textWrapper">
        <Link
          to="/privacy"
          style={{
            color: token?.Typography?.colorSecondaryLogoText,
            borderBottom:
              location?.pathname === "/privacy"
                ? "1.5px solid currentColor"
                : "none",
          }}
          onClick={() => {
            Utils?.scrollIntoViewByClassName(".standardHeader-cont");
          }}>
          Privacy
        </Link>
        <Link
          to="/terms"
          style={{
            color: token?.Typography?.colorSecondaryLogoText,
            borderBottom:
              location?.pathname === "/terms"
                ? "1.5px solid currentColor"
                : "none",
          }}
          onClick={() => {
            Utils?.scrollIntoViewByClassName(".standardHeader-cont");
          }}>
          Terms
        </Link>
      </div>
    </Footer>
  );
}
